import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "configs/configureStore";
import { DEFAULT, REGISTER } from "routes/route.constant";
import { Navigate, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Stack,
  Text,
  Button,
  PasswordInput,
  TextInput,
  Title,
  Group,
  TextProps,
  Container,
} from "@mantine/core";
import { LoginData } from "constants/types/auth";
import { login } from "redux/auth/slice";
import loginBg from "assets/images/login_bg.jpg";

import classes from "./Login.module.css";

const loginSchema = Yup.object().shape({
  username: Yup.string().required("Số điện thoại không được để trống."),
  password: Yup.string().required("Mật khẩu không được để trống"),
});

const LINK_PROPS: TextProps = {
  className: classes.link,
};

const Login: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const  isLoggedIn  = useSelector((state: RootState) => state.authSlice.isLoggedIn);

  const initialValue: LoginData = {
    username: "",
    password: "",
  };

  const handleLogin = (data: LoginData) => {
    dispatch(login(data));
  };

  const formLogin = useFormik({
    initialValues: initialValue,
    validationSchema: loginSchema,
    onSubmit: (data) => {
      try {
        const loginData: LoginData = {
          username: data.username,
          password: data.password,
        };
        handleLogin(loginData);
      } catch (error: any) {
        //console.log(error);
      }
    },
  });

  const handleRegisterRedirect = () => navigate(REGISTER);

  if (isLoggedIn) return <Navigate to={DEFAULT} replace />;

  return (
    <div className={classes.wrapper}>
      <Container size="lg" className={classes.container}>
        <div className={classes.formSection}>
          <div className={classes.header}>
            <Title order={2} className={classes.title}>
              Đăng nhập{" "}
              <span className={classes.highlight}>Kho thông minh</span>
            </Title>
            <Text c="dimmed" size="sm">
              Quản lý kho hàng trên máy của bạn
            </Text>
          </div>

          <form onSubmit={formLogin.handleSubmit}>
            <Stack mt="xl">
              <TextInput
                name="username"
                placeholder="Tên tài khoản"
                size="md"
                radius="md"
                className={classes["username-input"]}
                classNames={{ label: classes.label }}
                autoComplete="off"
                error={
                  formLogin.errors.username && formLogin.touched.username
                    ? formLogin.errors.username
                    : ""
                }
                value={formLogin.values.username}
                onChange={formLogin.handleChange}
              />

              <PasswordInput
                name="password"
                placeholder="Mật khẩu"
                size="md"
                radius="md"
                classNames={{ label: classes.label }}
                autoComplete="new-password"
                error={
                  formLogin.errors.password && formLogin.touched.password
                    ? formLogin.errors.password
                    : ""
                }
                value={formLogin.values.password}
                onChange={formLogin.handleChange}
              />

              <Group justify="space-between">
                <Text component="label" size="sm">
                  <input
                    type="checkbox"
                    // checked={form.values.remember}
                    // onChange={(e) =>
                    //   form.setFieldValue("remember", e.currentTarget.checked)
                    // }
                    className={classes.checkbox}
                  />
                  Ghi nhớ tài khoản
                </Text>
                <Text
                  component="a"
                  size="sm"
                  className={classes.forgotPassword}
                >
                  Quên tài khoản?
                </Text>
              </Group>

              <Group mt="lg">
                <Button
                  type="button"
                  variant="default"
                  className={classes.registerButton}
                  fullWidth
                  onClick={handleRegisterRedirect}
                >
                  Đăng ký
                </Button>
                <Button type="submit" className={classes.loginButton} fullWidth>
                  Đăng nhập
                </Button>
              </Group>
            </Stack>
          </form>
        </div>
      </Container>
    </div>
  );
};

export default Login;
